import client from "./client"

export const registrationService = {
    companyByVAT
};


function companyByVAT(vat){
    return client.post('/api/company-by-vat/', {
        'vat': vat
    })
}

